import { memo } from "react";
import { useTranslate } from "../../context/TranslationContext";
import { useStaticData } from "../../utils/data";
import CalculatorCard from "../cards/CalculatorCard";

const OtherFitnessTestSection = ({ data: customData }) => {
  const { FITNESSTEST } = useStaticData();
  const { t } = useTranslate("otherCalcTest");
  const list = customData || FITNESSTEST;

  return (
    <section className="latest-press py-sm-5 py-4">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h2 className="text-uppercase">{t("testTitle")}</h2>
          </div>
          {list.map((item) => (
            <div className="col-lg-4 col-md-6 my-3">
              <CalculatorCard data={item} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default memo(OtherFitnessTestSection);
